import { Button, Grid } from "@mui/material";
import Input from "./Input";
import { Controller, useForm } from "react-hook-form";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import PasswordIcon from "@mui/icons-material/Password";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useState } from "react";

export interface ChangePasswordFormData {
  currentPassword: string;
  newPassword: string;
  confirmNewPassword: string;
}

interface ChangePasswordFormProps {
  onSubmit: (data: ChangePasswordFormData) => void;
  isLoading: boolean;
}

const ChangePasswordForm = ({
  onSubmit,
  isLoading,
}: ChangePasswordFormProps) => {
  const { handleSubmit, control } = useForm<ChangePasswordFormData>();
  const onSubmitHandler = (data: ChangePasswordFormData) => {
    onSubmit(data);
  };

  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false);

  return (
    <form onSubmit={handleSubmit(onSubmitHandler)}>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 12 }}>
          <Controller
            control={control}
            rules={{
              required: "La contraseña actual es requerida",
            }}
            name="currentPassword"
            render={({ field, fieldState }) => (
              <Input
                label="Contraseña actual"
                name="currentPassword"
                required
                field={field}
                error={fieldState.error?.message}
                icon={
                  showCurrentPassword ? (
                    <VisibilityIcon />
                  ) : (
                    <VisibilityOffIcon />
                  )
                }
                type={showCurrentPassword ? "text" : "password"}
                onClickIcon={() => setShowCurrentPassword(!showCurrentPassword)}
              />
            )}
          />
        </Grid>

        <Grid size={{ xs: 12, md: 12 }}>
          <Controller
            control={control}
            rules={{
              required: "La nueva contraseña es requerida",
            }}
            name="newPassword"
            render={({ field, fieldState }) => (
              <Input
                label="Nueva contraseña"
                name="newPassword"
                required
                field={field}
                error={fieldState.error?.message}
                icon={
                  showNewPassword ? <VisibilityIcon /> : <VisibilityOffIcon />
                }
                type={showNewPassword ? "text" : "password"}
                onClickIcon={() => setShowNewPassword(!showNewPassword)}
              />
            )}
          />
        </Grid>

        <Grid size={{ xs: 12, md: 12 }}>
          <Controller
            control={control}
            rules={{
              required: "La confirmación de la nueva contraseña es requerida",
            }}
            name="confirmNewPassword"
            render={({ field, fieldState }) => (
              <Input
                label="Confirmar nueva contraseña"
                name="confirmNewPassword"
                required
                field={field}
                error={fieldState.error?.message}
                icon={
                  showConfirmNewPassword ? (
                    <VisibilityIcon />
                  ) : (
                    <VisibilityOffIcon />
                  )
                }
                type={showConfirmNewPassword ? "text" : "password"}
                onClickIcon={() =>
                  setShowConfirmNewPassword(!showConfirmNewPassword)
                }
              />
            )}
          />
        </Grid>
      </Grid>

      <Grid
        size={{ xs: 12, md: 12 }}
        sx={{ mt: 2, display: "flex", justifyContent: "center" }}
      >
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={isLoading}
          loading={isLoading}
          sx={{ width: "30%" }}
        >
          Cambiar contraseña
        </Button>
      </Grid>
    </form>
  );
};

export default ChangePasswordForm;
